import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should call its initialise() method, to set
// up the environment and create all of the resources the application will use.

class Resources {
    // createResources() should create a static field for each resource:
    //
    //    const env = Resources.env;
    //
    //    Resources.colours = env.resource('Colours')
    //                           .baseUrl('@AvatarAdminBaseUrl')
    //                           .service('colours');
    //
    //
    // Application code can then access those resources like so:
    //
    //    const allColours = Resource.colours.get().send();

    static createResources(parentEnv) {
        const env = parentEnv || Resources.env;

        this.productLicenses = env.resource('productLicenses')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/productLicenses');

        this.students = env.resource('students')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/students');

        this.studentsCsv = env.resource('studentsCsv')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/students/csv/{downloadKey}');

        this.yearGroups = env.resource('yearGroups')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/yeargroups');

        this.countryYearGroups = env.resource('countryYearGroups')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/yeargroups');

        this.downloadTemplateFile = env.resource('downloadTemplateFile')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/templates/{templateType}');

        this.quickUpload = env.resource('quickUpload')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/quickUpload');

        this.classrooms = env.resource('classrooms')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/products/{productId}');

        this.unassignStudents = env.resource('unassignStudents')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/classroomUsersRelation');

        this.getStudents = env.resource('getStudents')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/students/{userProfileId}');

        this.studentClassroomsRelation = env.resource('studentClassroomsRelation')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/students/{userProfileId}/products/{productId}/classroomsRelation');

        this.teacherClassroomsRelation = env.resource('teacherClassroomsRelation')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers/{userProfileId}/products/{productId}/classroomsRelation');

        this.teachers = env.resource('teachers')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers');

        this.addTeacher = env.resource('addTeacher')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers/invite');

        this.getTeachers = env.resource('getTeachers')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers/{userProfileId}');

        this.unassignTeachers = env.resource('unassignTeachers')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/classroomUsersRelation');

        this.bulkPasswordChangeStudents = env.resource('bulkPasswordChangeStudents')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/students/changePassword');

        this.bulkPasswordChangeTeachers = env.resource('bulkPasswordChangeTeachers')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers/changePassword');

        this.teachersSignInCards = env.resource('teachersSignInCards')
            .baseUrl('@SignInCardGatewayUrl')
            .service('api/v1/products/{productId}/teacherSignInCards');

        this.classStudentsSignInCards = env.resource('classStudentsSignInCards')
            .baseUrl('@SignInCardGatewayUrl')
            .service('api/v1/products/{productId}/studentSignInCards');

        this.classroomsStudentsSignInCards = env.resource('classroomsStudentsSignInCards')
            .baseUrl('@SignInCardGatewayUrl')
            .service('api/v1/products/{productId}/classroomSignInCards');

        this.teachersCsv = env.resource('teachersCsv')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers/csv/{downloadKey}');

        this.deleteStudents = env.resource('deleteStudents')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/students');

        this.deleteTeachers = env.resource('deleteTeachers')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers');

        this.classesCsv = env.resource('classesCsv')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/csv');

        this.getCourseCountries = env.resource('getCourseCountries')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/countries');

        this.getProductCourses = env.resource('getProductCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/courses');

        this.getSchoolCourses = env.resource('getSchoolCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/courses/schoolcourses');

        this.addClass = env.resource('addClass')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms');

        this.updateClassroomGroup = env.resource('updateClassroomGroup')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups/{groupId}');

        this.getClassById = env.resource('getClassById')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/{classroomId}');

        this.updateClass = env.resource('updateClass')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/{classroomId}');

        this.classroomUserRelation = env.resource('classroomUserRelation')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/classroomUsersRelation');

        this.deleteClassroomGroup = env.resource('deleteClassroomGroup')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups/{groupId}');

        this.changeClassroomCourse = env.resource('changeClassroomCourse')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups/{groupId}/checkTaskAndChangeCourse');

        this.getStudentsByClassroomId = env.resource('getStudentsByClassroomId')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/{classroomId}/students');

        this.addGroup = env.resource('addGroup')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups/registerGroup');

        this.getClassroomGroups = env.resource('getClassroomGroups')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups');

        this.moveStudents = env.resource('moveStudents')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/{classroomId}/moveStudents');

        this.deleteClassrooms = env.resource('deleteClassrooms')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/classrooms/bulk');

        this.changeCourseCarryOver = env.resource('changeCourseCarryOver')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups/{groupId}/updateTaskAndChangeCourse');

        this.verifyRollOver = env.resource('verifyRollOver')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/validateRollover');

        this.downloadSchoolRollData = env.resource('downloadSchoolRollData')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/schoolRollData');

        this.performRollover = env.resource('performRollover')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/rollover');

        this.extendingResultsStatus = env.resource('extendingResultsStatus')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/extendingResultsStatus');

        this.extendResults = env.resource('extendResults')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/extendResults');

        this.getDefaultCourses = env.resource('getDefaultCourses')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/schooldefaultcourses');

        this.getCourse = env.resource('getCourse')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/courses/{courseId}');

        this.getAcademicYear = env.resource('getAcademicYear')
            .baseUrl('@CertificatesGatewayUrl')
            .service('api/v1/certificates/academicYear');

        this.getCertificatesSummary = env.resource('getCertificatesSummary')
            .baseUrl('@CertificatesGatewayUrl')
            .service('api/v1/certificates/summary');

        this.downloadCertificates = env.resource('downloadCertificates')
            .baseUrl('@CertificatesGatewayUrl')
            .service('api/v1/certificates/download');

        this.saveSchoolDefaultCourses = env.resource('saveSchoolDefaultCourses')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/products/{productId}/schooldefaultcourses');

        this.checkCommonTasks = env.resource('checkCommonTasks')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/{classroomId}/groups/{groupId}/commonTasks');

        this.assignCourses = env.resource('assignCourses')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/schools/changeGroupsCourse');

        this.getTeacherAuthToken = env.resource('getTeacherAuthToken')
            .baseUrl('@UserPortalGateway')
            .service('api/v1/authentication/signIn/{userProfileType}/{userProfileId}');

        this.sendTeacherPassword = env.resource('sendTeacherPassword')
            .baseUrl('@SchoolRollGatewayUrl')
            .service('api/v1/teachers/sendResetPasswordLink');

        this.sendVerificationEmail = env.resource('sendVerifyEmailLink')
            .baseUrl('@UserPortalGateway')
            .service('api/v1/sendVerificationEmail');

        this.sendVerificationEmails = env.resource('sendVerifyEmailLinks')
            .baseUrl('@UserPortalGateway')
            .service('api/v1/sendVerificationEmails');

        this.getFilteredCourses = env.resource('getFilteredCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/courses/filter');

        this.getConquestFilteredCourses = env.resource('getConquestFilteredCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('api/v1/courses/conquest/filter');
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./app/helpers/resources.js